import { useDispatch } from 'react-redux';
import { $api } from '@service/RequestService';
import { timeStampToDate } from '@utils/index';
import { useQuery } from 'react-query';
import { useQueryParams } from 'use-query-params';

import { offerConstants, offerModels, setTableItems } from '..';

export function useOffers(realtorId?: number) {
  const dispatch = useDispatch();
  const [query] = useQueryParams(offerConstants.offerQueryParams);

  const initial = {
    offers: [],
    totalPages: 0,
    currentPage: 1,
    totalElements: 0
  };

  const payload = { ...(query || {}) };

  if (realtorId) {
    payload.realtors = [realtorId];
  }

  const { data = initial, ...arg } = useQuery<{
    offers: offerModels.OfferType[];
    totalPages: number;
    currentPage: number;
    totalElements: number;
  }>([offerConstants.queryKeys.OFFER, payload], async () => {
    const { data } = await $api.post('/v1/offer/filter', payload);

    const totalPages = data?.data?.totalPages || 0;
    const currentPage = data?.data?.currentPage || 1;
    const totalElements = data?.data?.totalElements || 0;

    dispatch(
      setTableItems({
        totalPages,
        currentPage,
        totalElements
      })
    );

    const offers: offerModels.OfferType[] = data?.data?.data;

    return {
      offers: offers
        ? offers?.map(item => ({
          ...item,
          cratedDate: timeStampToDate({ date: item?.cratedDate, timeStamp: item?.cratedTimestamp }),
          updateDate: timeStampToDate({ date: item?.updateDate, timeStamp: item?.updateTimestamp })
        }))
        : offers,
      totalPages,
      currentPage,
      totalElements
    };
  });

  return { ...data, ...arg };
}
